import React, { useState, useEffect, useContext } from "react";

import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
// import Sidebar from "../../../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../../api/tmdbApi";
import Select from 'react-select';
import parse from "react-html-parser";
import SweetAlert from 'react-bootstrap-sweetalert';
import Modal from 'react-bootstrap/Modal';
import DataTable from 'react-data-table-component';
import Loader from "../../../components/loader";

let { lambda, appname } = window.app

const ActiveResult = ({ navigatePage, setCompleted, cpcInfoRes }) => {
    console.log("respppppppppppppppppppppppppppppppp", cpcInfoRes)
    const navigate = useNavigate()
    const [data, setData] = useState(null)
    const [cpcResult, setCPCResult] = useState([])
    const [answerpoints, setAnswerResult] = useState(null)
    const [id, setId] = useState(null)
    const [selectedCases, setSelectedCases] = useState({})
    const [setCases, setPointCases] = useState({})
    const [pointSuccess, setPointSuccess] = useState(false);
    const [mailSuccess, setMailSuccess] = useState(false)
    const [anncouncePopup, setAnnouncePopup] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [errorPopup, seterrorPopup] = useState(false)
    const [errormessage, setErroMessage] = useState("")
    const [matchlength, setMatchLength] = useState(false)
    const [submitDisable, setSubmitDisable] = useState(false)
    const [isLoading, setIsLoading] = useState(false);


    console.log('data->>>>>>>>>>>>>>>>>>>>>>',data)
    const points = [
        { value: 1.00, label: "1.00" },
        { value: 0.75, label: "0.75" },
        { value: 0.50, label: "0.50" },
        { value: 0.25, label: "0.25" },
        { value: 0.00, label: "0.00" }
    ]

    useEffect(() => {
        getCpcInfo()
        // announceResult()
    }, [])

    useEffect(() => {
        console.log('cpcInfoRes ', cpcInfoRes?.status)
        // if(cpcInfoRes?.scheduleEndDate){
        //     const time = cpcInfoRes?.scheduleEndDate;
        //     const currentTime = new Date();
        //     const targetTime = new Date(time);

        //     if (currentTime > targetTime) {
        //         setSubmitDisable(false)
        //         console.log("Current time is greater than target time");
        //     } else {
        //         setSubmitDisable(true)
        //         console.log("Current time is not greater than target time");
        //     }
        // }

        if (cpcInfoRes?.status == "RESULT PENDING") {
            setSubmitDisable(true)
        } else if (cpcInfoRes?.status == "ACTIVE") {
            setSubmitDisable(false)
        }
    }, [cpcInfoRes]);

    const getCpcInfo = async () => {
        setIsLoading(true);
        try {
            let cpcid = localStorage.getItem('cpcid')
            const response = await tmdbApi.cpcAnswersInfo(cpcid);
            if (response?.result) {
                if (response?.result == "No CPC Participants found." || response?.result == "No CPC data found.") {
                    setData({})
                } else {
                    setData(response?.result)
                    matchSubmitLength(response?.result)
                }

                let resultData = response?.result
                let setcasesObject = {}
                if (Object.keys(resultData)?.length > 0) {
                    Object.keys(resultData)?.map((item, key) => {

                        resultData[item]?.answers?.length > 0 && resultData[item]?.answers?.map((aitem, index) => {
                            let name = "answer-" + key + "-" + index
                            let object = {
                                value: aitem?.weightage,
                                label: aitem?.weightage
                            }
                            setSelectedCases(prev => ({
                                ...prev,
                                [name]: object
                            }));
                        })

                        if (resultData[item]?.answers?.length > 0) {
                            setcasesObject[resultData[item]?.caseid] = resultData[item]?.answers
                        }
                    })

                    setPointCases(setcasesObject)
                }
            }
        } catch (error) {
            console.error("Error fetching CPC info:", error);
        } finally {
            setIsLoading(false);
        }
    }

    const announceResult = async () => {
        let cpcid = localStorage.getItem('cpcid')
        const response = await tmdbApi.cpcannounceResult(cpcid);
        if (response?.result) {
            setCPCResult(response?.result)
        }
    }

    const matchSubmitLength = async (result) => {
        // Get the total objects length
        const objectsLength = Object.keys(result).length - 2;

        // Count the objects with submit true
        const submitLength = Object.values(result).filter(item => item.submit === true).length;

        // Check if lengths match
        const lengthsMatch = (objectsLength === submitLength);
        setMatchLength(lengthsMatch)
    }

    const handleChange = (e, name, caseId, answer) => {

        //   setSelectedCases(selectedOptions || []);
        setSelectedCases(prev => ({
            ...prev,
            [name]: e
        }));

        let selectedOption = {
            answer: answer,
            weightage: e.value
        }
        setPointCases(prev => {
            const existingArray = prev[caseId] || [];

            // Check if the item already exists by value
            const index = existingArray.findIndex(item => item.answer === answer);

            let updatedArray;
            if (index > -1) {
                // Update existing item
                updatedArray = [...existingArray];
                updatedArray[index] = selectedOption;
            } else {
                // Add new item
                updatedArray = [...existingArray, selectedOption];
            }

            return {
                ...prev,
                [caseId]: updatedArray
            };
        });

        // setPointCases(prev => ({
        //     ...prev,
        //     [caseid]: [...(prev[caseid] || []), answerValue]
        // }));
    };

    const handleClick = async (e, caseid) => {
        let answersPayload = setCases[caseid]
        let payload = {
            "answers": answersPayload
        }

        let cpcid = localStorage.getItem('cpcid')
        const response = await tmdbApi.cpcCaseSubmit(payload, cpcid, caseid);
        if (response?.result) {
            setPointSuccess(true)
            setAnswerResult(response?.result)
        }
    };

    const handleRowSelected = (state) => {
        setSelectedRows(state.selectedRows);
    };

    const sendResult = async (e) => {
        let mergedArray = cpcResult.map(item => {
            let isWinner = selectedRows.some(r => r.userid === item.userid);
            return {
                userid: item.userid,
                score: item.cpcResult,
                percentile: item.percentileRank,
                winner: isWinner
            };
        });
        let payload = {
            "result": mergedArray
        }
        console.log("payload", payload)
        let cpcid = localStorage.getItem('cpcid')
        try {
            const response = await tmdbApi.cpcsendResult(payload, cpcid);
            if (response?.result) {
                setMailSuccess(true)
            }
        } catch (err) {
            console.log("error", err?.message);
            setErroMessage(err?.message)
            seterrorPopup(true)
        }
    };

    const announceWinner = async (e) => {
        setAnnouncePopup(true)
        announceResult()
    }

    const pointSuccessClose = async (e) => {
        setPointSuccess(false)
        getCpcInfo()
    }

    const navigateComplete = (e) => {
        navigatePage("completed")
        setCompleted(false)
        setMailSuccess(false)
    }

    const columns = [
        {
            name: 'Participants',
            selector: row => row?.userName || row?.userid,
            sortable: false,
        },
        {
            name: 'Score',
            cell: (props) =>
                <div className="d-flex">
                    {props?.cpcResult}
                </div>
        },
        {
            name: 'Percentile',
            cell: (props) =>
                <div className="d-flex">
                    {props?.percentileRank}
                </div>
        },
    ];

    const handleViewCase = () => {
        navigate("/cpcinfo/" + cpcInfoRes.cpcid, {
            state: { caseid: cpcInfoRes.cases, cpcid: cpcInfoRes.cpcid, routeFrom: "announceResult" }
        })
    }
    // console.log("selectedCases ", selectedCases, JSON.stringify(setCases))

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <>

                    {/* Button with Bootstrap classes to align right */}
                    <div className="accordion" id="accordionExample">
                        {data && Object.keys(data).length > 0 ? (
                            <div className="row text-center mt-1 ms-1 me-1">
                                <b className="mb-1 p-0">
                                    <div className="d-flex justify-content-between cpcquiz-title">

                                        {/* CPC Title:  */}
                                        <span className="fw-bold">{data?.title}</span>
                                        <span className="fw-semibold d-flex gap-3 align-items-center">
                                            <button className="btn btn-primary create-quiz-btn border-0" onClick={(e) => handleViewCase(e, "s")} id={"cpc-answers-point-"}>
                                                View Case Images
                                            </button>
                                            Participants: <strong>{data?.participants}</strong>
                                        </span>
                                    </div>
                                </b>
                                {Object.keys(data)?.map((item, key) => {

                                    // console.log('item', data[item])

                                    return (
                                        item != "title" && item != "participants" && (

                                            <div className="accordion-item" key={key}>
                                                {/* <h2 className="accordion-header" id="headingOne"> */}
                                                <button style={{ fontWeight: 'bold' }} className="accordion-button fw-medium" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + key} aria-expanded="true" aria-controls={"collapse" + key}>
                                                    {`Case ${key + 1}`}
                                                </button>
                                                <div id={"collapse" + key} className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <table className="table table-bordered align-middle nowrap">
                                                            <thead className="table-primary">
                                                                <tr>
                                                                    <th scope="col" width="5%">No</th>
                                                                    <th scope="col" width="72%" style={{ textAlign: "left" }}>Answer</th>
                                                                    <th scope="col" width="10%">Count</th>
                                                                    <th scope="col" width="13%">Points</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {data[item] && data[item]?.answers?.length > 0 && data[item]?.answers?.map((aitem, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td scope="row">{index + 1}</td>
                                                                            <td align="left">
                                                                                <span>{aitem?.answer}</span>
                                                                            </td>
                                                                            <td align="center">
                                                                                <span>{aitem?.count}</span>
                                                                            </td>
                                                                            <td>
                                                                                <Select
                                                                                    isMulti={false}
                                                                                    isSearchable={false}
                                                                                    value={selectedCases["answer-" + key + "-" + index]}
                                                                                    options={points}
                                                                                    name={"answer-" + key + "-" + index}
                                                                                    onChange={(e) =>
                                                                                        handleChange(
                                                                                            e,
                                                                                            "answer-" + key + "-" + index,
                                                                                            data[item]?.caseid,
                                                                                            aitem?.answer
                                                                                        )
                                                                                    }
                                                                                    placeholder="Select Point"
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </tbody>
                                                        </table>
                                                        {data[item] && data[item]?.answers?.length > 0 &&
                                                            <button className="btn btn-primary create-quiz-btn border-0" onClick={(e) => handleClick(e, data[item]?.caseid)} id={"cpc-answers-point-" + key}>
                                                                Submit
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )
                                })}
                            </div>
                        ) : (
                            <div className="row text-center mt-5">
                                <div className="empty-state-body empty-record">
                                    <div className="empty-state__message">
                                        <span className="material-icons">summarize</span>
                                        <p className="form-check font-size-16">No CPC Participants Found</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {cpcInfoRes?.status == "RESULT PENDING" &&
                            <button className="btn btn-primary create-quiz-btn border-0 mt-3" onClick={(e) => announceWinner(e)}>
                                Announce Result
                            </button>
                        }
                    </div>
                </>
            )}

            <SweetAlert show={pointSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Points are Submitted Successfully"}
                onConfirm={e => pointSuccessClose(e)}
            >
            </SweetAlert>

            <SweetAlert show={mailSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Mail Send Successfully"}
                onConfirm={e => navigateComplete(e)}
            >
            </SweetAlert>

            <SweetAlert show={errorPopup}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={errormessage}
                onConfirm={e => seterrorPopup(false)}
            >
            </SweetAlert>

            <Modal className="announce-winner" show={anncouncePopup}>
                <div className="modal-body enquiry-form fullscreen-modal">
                    <div className="container cpc-active-table">
                        <button className="close-btn" onClick={e => setAnnouncePopup(false)}>
                            <span className="material-icons">close</span>
                        </button>
                        <DataTable
                            columns={columns}
                            data={cpcResult}
                            pagination
                            highlightOnHover
                            striped
                            selectableRows={true}
                            onSelectedRowsChange={handleRowSelected}
                            selectableRowsNoSelectAll
                        />
                        {selectedRows && selectedRows?.length > 0 &&
                            <button className="btn btn-primary create-quiz-btn border-0" onClick={(e) => sendResult(e)}>
                                Announce Winner
                            </button>
                        }
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ActiveResult;